import Sortable from 'sortablejs';
import Alpine from 'alpinejs'

window.$ = window.jQuery = require("jquery");
window.slick = require('slick-carousel');
window.Sortable = Sortable;
window.imgCheckbox = require("imgcheckbox");
window.Alpine = Alpine

require("./bootstrap");
require("./layouts.js");
require("./artworks");
require("./artist");
require("select2");
require("selectize");
require("./uppy.js");

Alpine.start()